<template>
  <div class="sc-suggestions-row" :style="containerStyle">
    <button v-for="(qr, i) in quickReplies"
            class="sc-suggestions-element"
            :key="i"
            :style="styles"
    >
      {{ qr }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'ChatPreviewQuickReplies',

  props: {
    themeConfig: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      quickReplies: ['🍽 Reservation', '🍔 Food', '🍹 Drinks', '⏰ Opening hours']
    }
  },

  computed: {
    containerStyle() {
      return {
        background: this.themeConfig.sentMessage.wrapperBg
      }
    },
    styles() {
      return {
        '--color': this.themeConfig.sentMessage.qr.text,
        '--border-color': this.themeConfig.sentMessage.qr.borderColor,
        '--background-color': this.themeConfig.sentMessage.qr.bg || 'white',
        '--background-color-hover': this.themeConfig.sentMessage.qr.bgHover,
        '--border-color-hover': this.themeConfig.sentMessage.qr.borderColorHover,
        '--color-hover': this.themeConfig.sentMessage.qr.textHover,
        fontFamily: this.themeConfig.font
      }
    }
  }
}
</script>
